import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
  init() {
    var cta = $('.solution-cta');
    var contents = $('.solution-text');
    var solution = $('.solution');
    var solutionTL = gsap.timeline({
      scrollTrigger : {
        trigger: "#block-home-solutions",
        start: 'top center',
        toggleActions: 'play none none none'
      }
    });

    solutionTL
      .to(contents,{autoAlpha:1})
      .to(cta, {autoAlpha:1 })
      .to(solution, {autoAlpha:1, stagger:.5});

    // Sets
    gsap.set(contents, {autoAlpha:1});
    gsap.set(cta, {autoAlpha: 0 });
    gsap.set(solution, {autoAlpha:1 });
  },
  finalize() {}
}